import React, { useMemo } from "react";
import UserContext from "./UserContext";
import getUserDetail from "../utils/getUserDetail";
import { useUsersList } from "../hooks/api/use-common";

const UserState = ({ children }) => {
  const userData = getUserDetail();
  const { data: allUsers = [], isLoading: selectAdminLoading } = useUsersList({
    enabled: !!userData?.id,
  });

  const filteredAdmins = useMemo(() => {
    if (!userData?.id) return allUsers;
    return allUsers.filter(
      (admin) => Number(admin.id) !== Number(userData.id)
    );
  }, [allUsers, userData?.id]);

  return (
    <UserContext.Provider
      value={{
        userId: userData?.id || 0,
        selectAllAdmins: filteredAdmins,
        selectAdminLoading,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserState;
